import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updateMetaTags } from '../utils/seo';
import Translate from '../components/Translate';
import PageBanner from '../components/PageBanner';

const VariousFileFormats = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('various_file_formats')} | ${t('site-title')}`,
            t('various_file_formats_desc'),
            "file formats, pdf viewer, office viewer, accessibility"
        );
    }, [t, i18n.language]);

    const formats = [
        {
            type: t('pdf-content'),
            links: [
                { name: t('adobe-reader'), url: "https://get.adobe.com/reader/" }
            ]
        },
        {
            type: t('word-excel-ppt'),
            links: [
                { name: t('ms-office-viewers'), url: "https://support.microsoft.com/en-us/office/view-office-files-without-an-office-subscription-29938b80-1a6c-4860-9e0c-843e9331f91b" }
            ]
        },
        {
            type: t('audio-content'),
            links: [
                { name: t('win-media-player'), url: "https://support.microsoft.com/en-us/windows/get-windows-media-player-81718e2d-3032-0268-bd98-729f2762e105" }
            ]
        }
    ];

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16 text-left">
            <PageBanner
                title={<Translate text={'various_file_formats'} />}
                subtitle={<Translate text={'various_file_formats-subtitle'} />}
                badgeText={t('badge-accessibility-support')}
            />
            <div className="max-w-5xl mx-auto px-4 py-12 sm:px-6 lg:px-8 mt-12">
                <div className="bg-white rounded-[24px] shadow-sm border border-[#dadce0] overflow-hidden">
                    <div className="p-8 border-b border-gray-100 bg-gray-50/30">
                        <p className="text-gray-700 leading-relaxed text-sm">
                            {t('various_file_formats_desc')}
                        </p>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50/50">
                                <tr>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">{t('document-type')}</th>
                                    <th scope="col" className="px-8 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">{t('download')}</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {formats.map((format, idx) => (
                                    <tr key={idx} className="hover:bg-primary-50/20 transition-colors">
                                        <td className="px-8 py-5 whitespace-nowrap text-sm font-bold text-gray-800">
                                            {format.type}
                                        </td>
                                        <td className="px-8 py-5 text-sm text-gray-600">
                                            <ul className="space-y-1">
                                                {format.links.map((link, lIdx) => (
                                                    <li key={lIdx}>
                                                        <a 
                                                            href={link.url} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="text-primary-600 hover:text-primary-700 hover:underline font-medium inline-flex items-center gap-1"
                                                        >
                                                            {link.name}
                                                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                            </svg>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VariousFileFormats;
